@file:OptIn(InternalResourceApi::class)

package gamerlogue.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gamerlogue.sharedui.generated.resources/"

@delegate:ResourceContentHash(1_735_748_073)
internal val Res.string.events__empty: StringResource by lazy {
      StringResource("string:events__empty", "events__empty", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6841, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6399, 45),
      ))
    }

@delegate:ResourceContentHash(-928_339_457)
internal val Res.string.events__error: StringResource by lazy {
      StringResource("string:events__error", "events__error", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6899, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6445, 49),
      ))
    }

@delegate:ResourceContentHash(-469_310_004)
internal val Res.string.events__live_now: StringResource by lazy {
      StringResource("string:events__live_now", "events__live_now", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6965, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6495, 36),
      ))
    }

@delegate:ResourceContentHash(1_404_503_813)
internal val Res.string.events__live_stream: StringResource by lazy {
      StringResource("string:events__live_stream", "events__live_stream", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7002, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6532, 43),
      ))
    }

@delegate:ResourceContentHash(-1_815_600_920)
internal val Res.string.events__logo: StringResource by lazy {
      StringResource("string:events__logo", "events__logo", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7042, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6576, 36),
      ))
    }

@delegate:ResourceContentHash(1_687_231_378)
internal val Res.string.events__next: StringResource by lazy {
      StringResource("string:events__next", "events__next", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7079, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6613, 32),
      ))
    }

@delegate:ResourceContentHash(842_207_073)
internal val Res.string.events__past: StringResource by lazy {
      StringResource("string:events__past", "events__past", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7116, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6646, 32),
      ))
    }

@delegate:ResourceContentHash(588_971_377)
internal val Res.string.events__retry: StringResource by lazy {
      StringResource("string:events__retry", "events__retry", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7153, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6679, 29),
      ))
    }

@delegate:ResourceContentHash(1_883_620_294)
internal val Res.string.events__upcoming: StringResource by lazy {
      StringResource("string:events__upcoming", "events__upcoming", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7187, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6709, 36),
      ))
    }

@delegate:ResourceContentHash(2_090_574_620)
internal val Res.string.exception__action_close: StringResource by lazy {
      StringResource("string:exception__action_close", "exception__action_close", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7224, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6746, 39),
      ))
    }

@delegate:ResourceContentHash(325_304_329)
internal val Res.string.exception__action_dismiss: StringResource by lazy {
      StringResource("string:exception__action_dismiss", "exception__action_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7264, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6786, 49),
      ))
    }

@delegate:ResourceContentHash(679_677_394)
internal val Res.string.exception__action_show: StringResource by lazy {
      StringResource("string:exception__action_show", "exception__action_show", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7314, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6836, 54),
      ))
    }

@delegate:ResourceContentHash(361_903_522)
internal val Res.string.exception__details_copy: StringResource by lazy {
      StringResource("string:exception__details_copy", "exception__details_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7377, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6891, 47),
      ))
    }

@delegate:ResourceContentHash(-1_146_818_911)
internal val Res.string.exception__details_hide: StringResource by lazy {
      StringResource("string:exception__details_hide", "exception__details_hide", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7429, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6939, 63),
      ))
    }

@delegate:ResourceContentHash(-167_487_229)
internal val Res.string.exception__details_show: StringResource by lazy {
      StringResource("string:exception__details_show", "exception__details_show", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7497, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7003, 63),
      ))
    }

@delegate:ResourceContentHash(-639_695_061)
internal val Res.string.exception__fallback_message: StringResource by lazy {
      StringResource("string:exception__fallback_message", "exception__fallback_message", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7561, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7067, 75),
      ))
    }

@delegate:ResourceContentHash(1_278_844_082)
internal val Res.string.exception__generic_error: StringResource by lazy {
      StringResource("string:exception__generic_error", "exception__generic_error", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7649, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7143, 40),
      ))
    }

@delegate:ResourceContentHash(1_221_181_415)
internal val Res.string.exception__hint_network: StringResource by lazy {
      StringResource("string:exception__hint_network", "exception__hint_network", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7690, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7184, 99),
      ))
    }

@delegate:ResourceContentHash(469_280_821)
internal val Res.string.exception__title: StringResource by lazy {
      StringResource("string:exception__title", "exception__title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7806, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7284, 52),
      ))
    }

@delegate:ResourceContentHash(-562_862_428)
internal val Res.string.exception__type_label: StringResource by lazy {
      StringResource("string:exception__type_label", "exception__type_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7337, 37),
      ))
    }

@delegate:ResourceContentHash(-1_059_599_958)
internal val Res.string.game__age_ratings_title: StringResource by lazy {
      StringResource("string:game__age_ratings_title", "game__age_ratings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7867, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7375, 47),
      ))
    }

@delegate:ResourceContentHash(540_958_349)
internal val Res.string.game__alternative_names_title: StringResource by lazy {
      StringResource("string:game__alternative_names_title", "game__alternative_names_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7931, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7423, 61),
      ))
    }

@delegate:ResourceContentHash(-253_449_602)
internal val Res.string.game__artwork_image: StringResource by lazy {
      StringResource("string:game__artwork_image", "game__artwork_image", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7993, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7485, 47),
      ))
    }

@delegate:ResourceContentHash(1_607_792_692)
internal val Res.string.game__bundles_title: StringResource by lazy {
      StringResource("string:game__bundles_title", "game__bundles_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8045, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7533, 39),
      ))
    }

@delegate:ResourceContentHash(634_141_019)
internal val Res.string.game__collections_title: StringResource by lazy {
      StringResource("string:game__collections_title", "game__collections_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8081, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7573, 47),
      ))
    }

@delegate:ResourceContentHash(-1_719_265_545)
internal val Res.string.game__description_title: StringResource by lazy {
      StringResource("string:game__description_title", "game__description_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8129, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7621, 47),
      ))
    }

@delegate:ResourceContentHash(627_669_149)
internal val Res.string.game__details_collection: StringResource by lazy {
      StringResource("string:game__details_collection", "game__details_collection", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8177, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7669, 48),
      ))
    }

@delegate:ResourceContentHash(1_549_119_175)
internal val Res.string.game__details_developers: StringResource by lazy {
      StringResource("string:game__details_developers", "game__details_developers", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8226, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7718, 48),
      ))
    }

@delegate:ResourceContentHash(924_951_566)
internal val Res.string.game__details_engines: StringResource by lazy {
      StringResource("string:game__details_engines", "game__details_engines", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8275, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7767, 45),
      ))
    }

@delegate:ResourceContentHash(-97_318_048)
internal val Res.string.game__details_franchise: StringResource by lazy {
      StringResource("string:game__details_franchise", "game__details_franchise", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8325, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7813, 43),
      ))
    }

@delegate:ResourceContentHash(-7_304_315)
internal val Res.string.game__details_languages: StringResource by lazy {
      StringResource("string:game__details_languages", "game__details_languages", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8369, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7857, 55),
      ))
    }

@delegate:ResourceContentHash(-1_371_275_977)
internal val Res.string.game__details_parent_game: StringResource by lazy {
      StringResource("string:game__details_parent_game", "game__details_parent_game", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8425, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7913, 45),
      ))
    }

@delegate:ResourceContentHash(-1_263_405_668)
internal val Res.string.game__details_platforms: StringResource by lazy {
      StringResource("string:game__details_platforms", "game__details_platforms", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8475, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7959, 43),
      ))
    }

@delegate:ResourceContentHash(1_616_092_736)
internal val Res.string.game__details_publishers: StringResource by lazy {
      StringResource("string:game__details_publishers", "game__details_publishers", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8523, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8003, 48),
      ))
    }

@delegate:ResourceContentHash(-1_593_725_404)
internal val Res.string.game__details_release_date: StringResource by lazy {
      StringResource("string:game__details_release_date", "game__details_release_date", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8568, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8052, 50),
      ))
    }

@delegate:ResourceContentHash(-415_371_176)
internal val Res.string.game__details_status: StringResource by lazy {
      StringResource("string:game__details_status", "game__details_status", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8627, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8103, 44),
      ))
    }

@delegate:ResourceContentHash(-1_944_009_407)
internal val Res.string.game__details_type: StringResource by lazy {
      StringResource("string:game__details_type", "game__details_type", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8676, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8148, 38),
      ))
    }

@delegate:ResourceContentHash(-683_412_282)
internal val Res.string.game__dlcs_expansions_title: StringResource by lazy {
      StringResource("string:game__dlcs_expansions_title", "game__dlcs_expansions_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8723, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8187, 59),
      ))
    }

@delegate:ResourceContentHash(-1_685_204_518)
internal val Res.string.game__editions_title: StringResource by lazy {
      StringResource("string:game__editions_title", "game__editions_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8783, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8247, 40),
      ))
    }

@delegate:ResourceContentHash(-603_670_776)
internal val Res.string.game__expanded_games_title: StringResource by lazy {
      StringResource("string:game__expanded_games_title", "game__expanded_games_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8824, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8288, 58),
      ))
    }

@delegate:ResourceContentHash(215_493_876)
internal val Res.string.game__franchises_title: StringResource by lazy {
      StringResource("string:game__franchises_title", "game__franchises_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8883, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8347, 46),
      ))
    }

@delegate:ResourceContentHash(-401_245_401)
internal val Res.string.game__game_modes_title: StringResource by lazy {
      StringResource("string:game__game_modes_title", "game__game_modes_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8926, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8394, 46),
      ))
    }

@delegate:ResourceContentHash(-1_904_559_094)
internal val Res.string.game__genres_title: StringResource by lazy {
      StringResource("string:game__genres_title", "game__genres_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8981, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8441, 34),
      ))
    }

@delegate:ResourceContentHash(-1_590_643_104)
internal val Res.string.game__igdb_about: StringResource by lazy {
      StringResource("string:game__igdb_about", "game__igdb_about", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9397, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8809, 44),
      ))
    }

@delegate:ResourceContentHash(555_074_010)
internal val Res.string.game__igdb_about_body: StringResource by lazy {
      StringResource("string:game__igdb_about_body", "game__igdb_about_body", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9016, 333),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8476, 281),
      ))
    }

@delegate:ResourceContentHash(270_779_389)
internal val Res.string.game__igdb_about_title: StringResource by lazy {
      StringResource("string:game__igdb_about_title", "game__igdb_about_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9350, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8758, 50),
      ))
    }

@delegate:ResourceContentHash(-1_483_225_475)
internal val Res.string.game__igdb_edit: StringResource by lazy {
      StringResource("string:game__igdb_edit", "game__igdb_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9450, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8854, 39),
      ))
    }

@delegate:ResourceContentHash(1_849_783_092)
internal val Res.string.game__igdb_open: StringResource by lazy {
      StringResource("string:game__igdb_open", "game__igdb_open", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9498, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8894, 39),
      ))
    }

@delegate:ResourceContentHash(-1_018_456_355)
internal val Res.string.game__keywords_title: StringResource by lazy {
      StringResource("string:game__keywords_title", "game__keywords_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9538, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8934, 48),
      ))
    }

@delegate:ResourceContentHash(-961_422_624)
internal val Res.string.game__languages_audio: StringResource by lazy {
      StringResource("string:game__languages_audio", "game__languages_audio", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9595, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8983, 37),
      ))
    }

@delegate:ResourceContentHash(-1_290_051_884)
internal val Res.string.game__languages_interface: StringResource by lazy {
      StringResource("string:game__languages_interface", "game__languages_interface", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9633, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9021, 45),
      ))
    }

@delegate:ResourceContentHash(732_335_009)
internal val Res.string.game__languages_subtitles: StringResource by lazy {
      StringResource("string:game__languages_subtitles", "game__languages_subtitles", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9683, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9067, 45),
      ))
    }

@delegate:ResourceContentHash(-1_499_740_775)
internal val Res.string.game__load_error: StringResource by lazy {
      StringResource("string:game__load_error", "game__load_error", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9733, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9113, 64),
      ))
    }

@delegate:ResourceContentHash(-2_030_729_514)
internal val Res.string.game__multiplayer_title: StringResource by lazy {
      StringResource("string:game__multiplayer_title", "game__multiplayer_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9814, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9178, 67),
      ))
    }

@delegate:ResourceContentHash(-1_853_040_756)
internal val Res.string.game__no_description: StringResource by lazy {
      StringResource("string:game__no_description", "game__no_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9886, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9246, 60),
      ))
    }

@delegate:ResourceContentHash(364_646_657)
internal val Res.string.game__not_found: StringResource by lazy {
      StringResource("string:game__not_found", "game__not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9959, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9307, 55),
      ))
    }

@delegate:ResourceContentHash(618_597_835)
internal val Res.string.game__parent_games_title: StringResource by lazy {
      StringResource("string:game__parent_games_title", "game__parent_games_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10023, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9363, 60),
      ))
    }

@delegate:ResourceContentHash(820_917_400)
internal val Res.string.game__player_perspectives_title: StringResource by lazy {
      StringResource("string:game__player_perspectives_title", "game__player_perspectives_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10088, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9424, 55),
      ))
    }

@delegate:ResourceContentHash(1_531_222_635)
internal val Res.string.game__ports_title: StringResource by lazy {
      StringResource("string:game__ports_title", "game__ports_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10144, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9480, 33),
      ))
    }

@delegate:ResourceContentHash(-793_235_992)
internal val Res.string.game__rating_description: StringResource by lazy {
      StringResource("string:game__rating_description", "game__rating_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10182, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9514, 80),
      ))
    }

@delegate:ResourceContentHash(-1_446_943_456)
internal val Res.string.game__ratings_gamerlogue: StringResource by lazy {
      StringResource("string:game__ratings_gamerlogue", "game__ratings_gamerlogue", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10255, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9595, 48),
      ))
    }

@delegate:ResourceContentHash(-1_407_946_637)
internal val Res.string.game__ratings_igdb_critics: StringResource by lazy {
      StringResource("string:game__ratings_igdb_critics", "game__ratings_igdb_critics", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10304, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9644, 50),
      ))
    }

@delegate:ResourceContentHash(-596_554_224)
internal val Res.string.game__ratings_igdb_user: StringResource by lazy {
      StringResource("string:game__ratings_igdb_user", "game__ratings_igdb_user", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10355, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9695, 47),
      ))
    }

@delegate:ResourceContentHash(161_204_808)
internal val Res.string.game__ratings_title: StringResource by lazy {
      StringResource("string:game__ratings_title", "game__ratings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10403, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9743, 39),
      ))
    }

@delegate:ResourceContentHash(1_690_036_751)
internal val Res.string.game__release_dates_title: StringResource by lazy {
      StringResource("string:game__release_dates_title", "game__release_dates_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10447, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9783, 69),
      ))
    }

@delegate:ResourceContentHash(555_528_427)
internal val Res.string.game__remakes_remasters_title: StringResource by lazy {
      StringResource("string:game__remakes_remasters_title", "game__remakes_remasters_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10525, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9853, 65),
      ))
    }

@delegate:ResourceContentHash(588_971_377)
internal val Res.string.game__retry: StringResource by lazy {
      StringResource("string:game__retry", "game__retry", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10587, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9919, 27),
      ))
    }

@delegate:ResourceContentHash(1_433_209_122)
internal val Res.string.game__reviews_all: StringResource by lazy {
      StringResource("string:game__reviews_all", "game__reviews_all", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10619, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9947, 41),
      ))
    }

@delegate:ResourceContentHash(1_936_905_841)
internal val Res.string.game__reviews_average: StringResource by lazy {
      StringResource("string:game__reviews_average", "game__reviews_average", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10669, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9989, 49),
      ))
    }

@delegate:ResourceContentHash(1_100_959_692)
internal val Res.string.game__reviews_empty: StringResource by lazy {
      StringResource("string:game__reviews_empty", "game__reviews_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10723, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10039, 47),
      ))
    }

@delegate:ResourceContentHash(879_033_611)
internal val Res.string.game__reviews_title: StringResource by lazy {
      StringResource("string:game__reviews_title", "game__reviews_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10787, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10087, 39),
      ))
    }

@delegate:ResourceContentHash(-1_681_128_532)
internal val Res.string.game__show_less: StringResource by lazy {
      StringResource("string:game__show_less", "game__show_less", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10831, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10127, 35),
      ))
    }

@delegate:ResourceContentHash(-21_126_364)
internal val Res.string.game__show_more: StringResource by lazy {
      StringResource("string:game__show_more", "game__show_more", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10871, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10163, 35),
      ))
    }

@delegate:ResourceContentHash(665_453_996)
internal val Res.string.game__similar_games_title: StringResource by lazy {
      StringResource("string:game__similar_games_title", "game__similar_games_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10911, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10199, 53),
      ))
    }

@delegate:ResourceContentHash(-1_329_861_500)
internal val Res.string.game__standalone_expansions_title: StringResource by lazy {
      StringResource("string:game__standalone_expansions_title", "game__standalone_expansions_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10965, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10253, 69),
      ))
    }

@delegate:ResourceContentHash(1_200_757_468)
internal val Res.string.game__stores_title: StringResource by lazy {
      StringResource("string:game__stores_title", "game__stores_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11035, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10323, 34),
      ))
    }

@delegate:ResourceContentHash(2_085_663_620)
internal val Res.string.game__storyline_title: StringResource by lazy {
      StringResource("string:game__storyline_title", "game__storyline_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11070, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10358, 41),
      ))
    }

@delegate:ResourceContentHash(2_018_426_159)
internal val Res.string.game__themes_title: StringResource by lazy {
      StringResource("string:game__themes_title", "game__themes_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11108, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10400, 34),
      ))
    }

@delegate:ResourceContentHash(227_835_161)
internal val Res.string.game__time_to_beat_completionist: StringResource by lazy {
      StringResource("string:game__time_to_beat_completionist", "game__time_to_beat_completionist", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11143, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10435, 68),
      ))
    }

@delegate:ResourceContentHash(2_059_230_821)
internal val Res.string.game__time_to_beat_hastly: StringResource by lazy {
      StringResource("string:game__time_to_beat_hastly", "game__time_to_beat_hastly", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11208, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10504, 41),
      ))
    }

@delegate:ResourceContentHash(-2_064_960_158)
internal val Res.string.game__time_to_beat_main: StringResource by lazy {
      StringResource("string:game__time_to_beat_main", "game__time_to_beat_main", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11328, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10600, 47),
      ))
    }

@delegate:ResourceContentHash(-2_096_590_460)
internal val Res.string.game__time_to_beat_main_extra: StringResource by lazy {
      StringResource("string:game__time_to_beat_main_extra", "game__time_to_beat_main_extra", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11266, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10546, 53),
      ))
    }

@delegate:ResourceContentHash(-607_275_633)
internal val Res.string.game__websites_title: StringResource by lazy {
      StringResource("string:game__websites_title", "game__websites_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11384, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10648, 40),
      ))
    }

@delegate:ResourceContentHash(-2_056_211_247)
internal val Res.string.game__your_review: StringResource by lazy {
      StringResource("string:game__your_review", "game__your_review", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11425, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10689, 41),
      ))
    }

@delegate:ResourceContentHash(805_026_338)
internal val Res.string.game_card__hours_played: StringResource by lazy {
      StringResource("string:game_card__hours_played", "game_card__hours_played", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11475, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10731, 43),
      ))
    }

@delegate:ResourceContentHash(1_359_337_376)
internal val Res.string.game_category__bundle: StringResource by lazy {
      StringResource("string:game_category__bundle", "game_category__bundle", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11519, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10775, 37),
      ))
    }

@delegate:ResourceContentHash(80_414_688)
internal val Res.string.game_category__dlc: StringResource by lazy {
      StringResource("string:game_category__dlc", "game_category__dlc", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11557, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10813, 30),
      ))
    }

@delegate:ResourceContentHash(-659_718_788)
internal val Res.string.game_category__episode: StringResource by lazy {
      StringResource("string:game_category__episode", "game_category__episode", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11588, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10844, 42),
      ))
    }

@delegate:ResourceContentHash(-275_704_121)
internal val Res.string.game_category__expanded_game: StringResource by lazy {
      StringResource("string:game_category__expanded_game", "game_category__expanded_game", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11631, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10887, 56),
      ))
    }

@delegate:ResourceContentHash(-565_934_737)
internal val Res.string.game_category__expansion: StringResource by lazy {
      StringResource("string:game_category__expansion", "game_category__expansion", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11692, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10944, 44),
      ))
    }

@delegate:ResourceContentHash(-2_007_369_184)
internal val Res.string.game_category__fork: StringResource by lazy {
      StringResource("string:game_category__fork", "game_category__fork", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11741, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10989, 35),
      ))
    }

@delegate:ResourceContentHash(-327_158_655)
internal val Res.string.game_category__main_game: StringResource by lazy {
      StringResource("string:game_category__main_game", "game_category__main_game", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11777, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11025, 44),
      ))
    }

@delegate:ResourceContentHash(82_813_600)
internal val Res.string.game_category__mod: StringResource by lazy {
      StringResource("string:game_category__mod", "game_category__mod", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11834, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11070, 30),
      ))
    }

@delegate:ResourceContentHash(-1_315_329_632)
internal val Res.string.game_category__pack_addon: StringResource by lazy {
      StringResource("string:game_category__pack_addon", "game_category__pack_addon", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11865, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11101, 49),
      ))
    }

@delegate:ResourceContentHash(1_531_215_412)
internal val Res.string.game_category__port: StringResource by lazy {
      StringResource("string:game_category__port", "game_category__port", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11915, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11151, 35),
      ))
    }

@delegate:ResourceContentHash(-1_559_571_072)
internal val Res.string.game_category__remake: StringResource by lazy {
      StringResource("string:game_category__remake", "game_category__remake", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11955, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11187, 37),
      ))
    }

@delegate:ResourceContentHash(-58_022_421)
internal val Res.string.game_category__remaster: StringResource by lazy {
      StringResource("string:game_category__remaster", "game_category__remaster", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11993, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11225, 43),
      ))
    }

@delegate:ResourceContentHash(-1_635_888_015)
internal val Res.string.game_category__season: StringResource by lazy {
      StringResource("string:game_category__season", "game_category__season", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12041, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11269, 37),
      ))
    }

@delegate:ResourceContentHash(2_081_872_417)
internal val Res.string.game_category__standalone_expansion: StringResource by lazy {
      StringResource("string:game_category__standalone_expansion", "game_category__standalone_expansion", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12083, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11307, 71),
      ))
    }

@delegate:ResourceContentHash(-315_549_487)
internal val Res.string.game_category__unknown: StringResource by lazy {
      StringResource("string:game_category__unknown", "game_category__unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12155, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11379, 54),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("events__empty", Res.string.events__empty)
  map.put("events__error", Res.string.events__error)
  map.put("events__live_now", Res.string.events__live_now)
  map.put("events__live_stream", Res.string.events__live_stream)
  map.put("events__logo", Res.string.events__logo)
  map.put("events__next", Res.string.events__next)
  map.put("events__past", Res.string.events__past)
  map.put("events__retry", Res.string.events__retry)
  map.put("events__upcoming", Res.string.events__upcoming)
  map.put("exception__action_close", Res.string.exception__action_close)
  map.put("exception__action_dismiss", Res.string.exception__action_dismiss)
  map.put("exception__action_show", Res.string.exception__action_show)
  map.put("exception__details_copy", Res.string.exception__details_copy)
  map.put("exception__details_hide", Res.string.exception__details_hide)
  map.put("exception__details_show", Res.string.exception__details_show)
  map.put("exception__fallback_message", Res.string.exception__fallback_message)
  map.put("exception__generic_error", Res.string.exception__generic_error)
  map.put("exception__hint_network", Res.string.exception__hint_network)
  map.put("exception__title", Res.string.exception__title)
  map.put("exception__type_label", Res.string.exception__type_label)
  map.put("game__age_ratings_title", Res.string.game__age_ratings_title)
  map.put("game__alternative_names_title", Res.string.game__alternative_names_title)
  map.put("game__artwork_image", Res.string.game__artwork_image)
  map.put("game__bundles_title", Res.string.game__bundles_title)
  map.put("game__collections_title", Res.string.game__collections_title)
  map.put("game__description_title", Res.string.game__description_title)
  map.put("game__details_collection", Res.string.game__details_collection)
  map.put("game__details_developers", Res.string.game__details_developers)
  map.put("game__details_engines", Res.string.game__details_engines)
  map.put("game__details_franchise", Res.string.game__details_franchise)
  map.put("game__details_languages", Res.string.game__details_languages)
  map.put("game__details_parent_game", Res.string.game__details_parent_game)
  map.put("game__details_platforms", Res.string.game__details_platforms)
  map.put("game__details_publishers", Res.string.game__details_publishers)
  map.put("game__details_release_date", Res.string.game__details_release_date)
  map.put("game__details_status", Res.string.game__details_status)
  map.put("game__details_type", Res.string.game__details_type)
  map.put("game__dlcs_expansions_title", Res.string.game__dlcs_expansions_title)
  map.put("game__editions_title", Res.string.game__editions_title)
  map.put("game__expanded_games_title", Res.string.game__expanded_games_title)
  map.put("game__franchises_title", Res.string.game__franchises_title)
  map.put("game__game_modes_title", Res.string.game__game_modes_title)
  map.put("game__genres_title", Res.string.game__genres_title)
  map.put("game__igdb_about", Res.string.game__igdb_about)
  map.put("game__igdb_about_body", Res.string.game__igdb_about_body)
  map.put("game__igdb_about_title", Res.string.game__igdb_about_title)
  map.put("game__igdb_edit", Res.string.game__igdb_edit)
  map.put("game__igdb_open", Res.string.game__igdb_open)
  map.put("game__keywords_title", Res.string.game__keywords_title)
  map.put("game__languages_audio", Res.string.game__languages_audio)
  map.put("game__languages_interface", Res.string.game__languages_interface)
  map.put("game__languages_subtitles", Res.string.game__languages_subtitles)
  map.put("game__load_error", Res.string.game__load_error)
  map.put("game__multiplayer_title", Res.string.game__multiplayer_title)
  map.put("game__no_description", Res.string.game__no_description)
  map.put("game__not_found", Res.string.game__not_found)
  map.put("game__parent_games_title", Res.string.game__parent_games_title)
  map.put("game__player_perspectives_title", Res.string.game__player_perspectives_title)
  map.put("game__ports_title", Res.string.game__ports_title)
  map.put("game__rating_description", Res.string.game__rating_description)
  map.put("game__ratings_gamerlogue", Res.string.game__ratings_gamerlogue)
  map.put("game__ratings_igdb_critics", Res.string.game__ratings_igdb_critics)
  map.put("game__ratings_igdb_user", Res.string.game__ratings_igdb_user)
  map.put("game__ratings_title", Res.string.game__ratings_title)
  map.put("game__release_dates_title", Res.string.game__release_dates_title)
  map.put("game__remakes_remasters_title", Res.string.game__remakes_remasters_title)
  map.put("game__retry", Res.string.game__retry)
  map.put("game__reviews_all", Res.string.game__reviews_all)
  map.put("game__reviews_average", Res.string.game__reviews_average)
  map.put("game__reviews_empty", Res.string.game__reviews_empty)
  map.put("game__reviews_title", Res.string.game__reviews_title)
  map.put("game__show_less", Res.string.game__show_less)
  map.put("game__show_more", Res.string.game__show_more)
  map.put("game__similar_games_title", Res.string.game__similar_games_title)
  map.put("game__standalone_expansions_title", Res.string.game__standalone_expansions_title)
  map.put("game__stores_title", Res.string.game__stores_title)
  map.put("game__storyline_title", Res.string.game__storyline_title)
  map.put("game__themes_title", Res.string.game__themes_title)
  map.put("game__time_to_beat_completionist", Res.string.game__time_to_beat_completionist)
  map.put("game__time_to_beat_hastly", Res.string.game__time_to_beat_hastly)
  map.put("game__time_to_beat_main", Res.string.game__time_to_beat_main)
  map.put("game__time_to_beat_main_extra", Res.string.game__time_to_beat_main_extra)
  map.put("game__websites_title", Res.string.game__websites_title)
  map.put("game__your_review", Res.string.game__your_review)
  map.put("game_card__hours_played", Res.string.game_card__hours_played)
  map.put("game_category__bundle", Res.string.game_category__bundle)
  map.put("game_category__dlc", Res.string.game_category__dlc)
  map.put("game_category__episode", Res.string.game_category__episode)
  map.put("game_category__expanded_game", Res.string.game_category__expanded_game)
  map.put("game_category__expansion", Res.string.game_category__expansion)
  map.put("game_category__fork", Res.string.game_category__fork)
  map.put("game_category__main_game", Res.string.game_category__main_game)
  map.put("game_category__mod", Res.string.game_category__mod)
  map.put("game_category__pack_addon", Res.string.game_category__pack_addon)
  map.put("game_category__port", Res.string.game_category__port)
  map.put("game_category__remake", Res.string.game_category__remake)
  map.put("game_category__remaster", Res.string.game_category__remaster)
  map.put("game_category__season", Res.string.game_category__season)
  map.put("game_category__standalone_expansion", Res.string.game_category__standalone_expansion)
  map.put("game_category__unknown", Res.string.game_category__unknown)
}
